import { NotAllowedIcon } from "@chakra-ui/icons";
import { Badge, Box, Flex } from "@chakra-ui/react";
import { AiOutlineGlobal } from "react-icons/ai";
import { BsArchive, BsSend } from "react-icons/bs";
import { MdChecklist, MdIncompleteCircle } from "react-icons/md";
import { useIntl } from "react-intl";

import { BulkExportStatus } from "@nens/ldo/api-v1";

export function useExportStatusDescription() {
  const intl = useIntl();

  return function (status?: BulkExportStatus): string {
    const statusText =
      status === "incomplete"
        ? intl.formatMessage({ id: "status.incomplete", defaultMessage: "Incomplete" })
        : status === "submitted"
        ? intl.formatMessage({ id: "status.submitted", defaultMessage: "Submitted" })
        : status === "error"
        ? intl.formatMessage({ id: "status.error", defaultMessage: "Error" })
        : status === "complete"
        ? intl.formatMessage({ id: "status.complete", defaultMessage: "Complete" })
        : status === "shared"
        ? intl.formatMessage({ id: "status.shared", defaultMessage: "Shared" })
        : status === "archived"
        ? intl.formatMessage({ id: "status.archived", defaultMessage: "Archived" })
        : intl.formatMessage({ id: "status.unknown", defaultMessage: "Unknown" });

    return statusText;
  };
}

export function ExportStatus({ status }: { status: BulkExportStatus | undefined }) {
  const INCOMPLETE_COLOR = "orange";
  const SUBMITTED_COLOR = "yellow";
  const ERROR_COLOR = "red";
  const COMPLETE_COLOR = "green";
  const SHARED_COLOR = "teal";
  const ARCHIVED_COLOR = "blue";
  const UNDEFINED_COLOR = "gray";

  const getStatusText = useExportStatusDescription();

  const statusText = getStatusText(status);

  const statusColor =
    status === "incomplete"
      ? INCOMPLETE_COLOR
      : status === "submitted"
      ? SUBMITTED_COLOR
      : status === "error"
      ? ERROR_COLOR
      : status === "complete"
      ? COMPLETE_COLOR
      : status === "shared"
      ? SHARED_COLOR
      : status === "archived"
      ? ARCHIVED_COLOR
      : UNDEFINED_COLOR;

  const icon =
    status === "incomplete" ? (
      <Box mr={1}>
        <MdIncompleteCircle />
      </Box>
    ) : status === "submitted" ? (
      <Box mr={1}>
        <BsSend />
      </Box>
    ) : status === "error" ? (
      <NotAllowedIcon mr={1} />
    ) : status === "complete" ? (
      <Box mr={1}>
        <MdChecklist />
      </Box>
    ) : status === "shared" ? (
      <Box mr={1}>
        <AiOutlineGlobal />
      </Box>
    ) : status === "archived" ? (
      <Box mr="1">
        <BsArchive />
      </Box>
    ) : null;

  return (
    <Badge
      rounded="full"
      px="12px"
      py="4px"
      colorScheme={statusColor}
      fontSize="0.8em"
      fontWeight="semibold"
      cursor="pointer"
    >
      <Flex alignItems="center">
        {icon}
        {statusText}
      </Flex>
    </Badge>
  );
}
